import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';

import Factor from './Factor';
import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.admissions.application-factors.title',
    defaultMessage: 'Application Factors',
  },
  legend: {
    id: 'hubs.admissions.application-factors.legend',
    defaultMessage:
      'These are the factors that {school} considers when evaluating applicants.',
  },
});

export const IMPORTANCE_ORDER = [
  'Very Important',
  'Important',
  'Considered',
  'Not Considered',
];

function getOrderFromList(importance) {
  return IMPORTANCE_ORDER.indexOf(importance);
}

function formatFactors(applicationFactors) {
  const factors = applicationFactors
    .map(({ type, importance }) => ({
      type,
      importance: importance || 'Very Important',
      order: getOrderFromList(importance || 'Very Important'),
    }))
    .sort((a, b) => a.order - b.order);

  return groupBy(factors, 'importance');
}

function ApplicationFactors({ applicationFactors, collegeName, intl }) {
  if (isEmpty(applicationFactors)) {
    return null;
  }
  const groups = formatFactors(applicationFactors);
  return (
    <div className="application-factors common-full-width" data-cy="application-factors">
      <div className="common-core-width" data-cy="application-factors-container">
        <h2 tabIndex={0}>{intl.formatMessage(messages.title)}</h2>
        <p>
          {intl.formatMessage(messages.legend, {
            school: collegeName,
          })}
        </p>
        <div className="application-factors-content">
          {Object.keys(groups).map((k) => (
            <Factor factors={groups[k]} key={k} title={k} />
          ))}
        </div>
      </div>
    </div>
  );
}

ApplicationFactors.prototype = {
  applicationFactors: PropTypes.array,
  intl: PropTypes.object,
  collegeName: PropTypes.string,
};

export default injectIntl(ApplicationFactors);
